import moment from 'moment';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  notSet: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.notSet',
    defaultMessage: 'Not Set',
  },
  date: {
    id: 'phc-web-toolkit.subjectViewer.executiveSummary.start',
    defaultMessage: '{date, date, ::MM dd YYYY}',
  },
});

export const useDurationStrings = (carePlan: fhir.CarePlan) => {
  const { formatMessage } = useIntl();
  const start = carePlan.period?.start
    ? formatMessage(messages.date, {
        date: moment(carePlan.period.start).toDate(),
      })
    : formatMessage(messages.notSet);
  const end = carePlan.period?.end
    ? formatMessage(messages.date, {
        date: moment(carePlan.period.end).toDate(),
      })
    : formatMessage(messages.notSet);

  return { start, end };
};
